import { formatDate, NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { IconComponent } from '@shared/components/icon/icon.component';
import { MessagesConstants } from '@shared/constants/messages.constants';
import { ROUTING_PATH } from '@shared/constants/routingPath';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

import { AssignMonthCloseComponent } from '../../../assign-month-close/assign-month-close.component';

export const QuarterCloseBannerHeight = 58;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    TooltipDirective,
    NgClass,
    NgStyle,
    IconComponent,
    AssignMonthCloseComponent,
  ],
  selector: 'aux-quarter-close-banner',
  templateUrl: './quarter-close-banner.component.html',
})
export class QuarterCloseBannerComponent {
  bannerHeight = QuarterCloseBannerHeight;
  @Output() closeMonth = new EventEmitter();
  @Input() currentMonth = '';
  @Input() disabled = false;
  @Input() hasClosePermission = false;
  readonly routerLink = `/${ROUTING_PATH.CLOSING.INDEX}/${ROUTING_PATH.CLOSING.CHECKLIST}`;

  get closeMonthBtnText(): string {
    return this.currentMonth ? `Close ${formatDate(this.currentMonth, 'MMMM', 'en-US')}` : '';
  }

  get closeMonthText(): string {
    return this.currentMonth ? `Close ${formatDate(this.currentMonth, 'MMMM YYYY', 'en-US')}` : '';
  }

  get closeMonthTooltip(): string {
    if (this.disabled) {
      return 'You can’t close the month until you review and complete the checklist.';
    }

    if (!this.hasClosePermission) {
      return MessagesConstants.DO_NOT_HAVE_PERMISSIONS_TO_ACTION;
    }

    return '';
  }

  onCloseMonth(): void {
    this.closeMonth.emit();
  }
}
